import React, {Component} from 'react'
import locale from './locale'
import CurrentClassTable from './Tables/currentClassTable'
import PastClassTable from './Tables/pastClassTable'
import getStudentClass from 'controllers/student/getStudentClass'

class CourseRecord extends Component{
  constructor(props){
    super(props)

    this.state = {
      showCurrentTable: true,
      showPastTable: false,
      currentClassList: [],
      pastClassList: [],
    }
    this.getClassList = this.getClassList.bind(this);
  }

  componentWillMount(){
    const {studentId} = this.props

    this.getClassList(studentId);
  }

  getClassList() {
    const {studentId} = this.props

    getStudentClass(studentId, 'current_class')
    .then((res) => {this.setState({currentClassList: res.classList})})

    getStudentClass(studentId, 'past_class')
    .then((res) => {this.setState({pastClassList: res.classList})})
  }
  render(){
    const {studentId, studentInfo, checkStudentUpdate} = this.props
    let {showCurrentTable, showPastTable, currentClassList, pastClassList} = this.state;

    return(
      <div className='studentCourseRecord'>
        <div className='currrentClass'>
          <div className='currentClassHeader'>
            {showCurrentTable && <i className='fa icon-angle-down' onClick={() => {
              this.setState({showCurrentTable: false})
            }}></i>}
            {showCurrentTable === false && <i className='fa icon-angle-right' onClick={() => {
              this.setState({showCurrentTable: true})
            }}></i>
            }
            <span>{__('Current Class', locale)}</span>
            <span className="badge">{currentClassList.length}</span>
          </div>
          <CurrentClassTable schoolDetail={this.props.schoolDetail} showTable={showCurrentTable} studentId={studentId} classList={currentClassList} student={studentInfo} getClassList = {this.getClassList} checkStudentUpdate={checkStudentUpdate}/>
        </div>
        <div className='pastClass'>
          <div className='pastClassHeader'>
            {showPastTable && <i className='fa icon-angle-down' onClick={() => {
              this.setState({showPastTable: false})
            }}></i>}
            {showPastTable === false && <i className='fa icon-angle-right' onClick={() => {
              this.setState({showPastTable: true})
            }}></i>}
            <span>{__('Past Class', locale)}</span>
            <span className="badge">{pastClassList.length}</span>
          </div>
          <PastClassTable schoolDetail={this.props.schoolDetail} showTable={showPastTable} studentId={studentId} classList={pastClassList} />
        </div>
      </div>
    )
  }
}


export default CourseRecord



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/CourseRecord.js